import { ReactNode } from "react";

export enum NotificationType {
    EMAIL = "EMAIL",
    EMAIL_CATERING = "EMAIL_CATERING",
    SMS = "SMS",
}

export type NotificationModalProps = {
    header: string,
    subHeader: string,
    body?: string,
    confirmBtnText?: string,
    cancelBtnText?: string,
};

export type NotificationDetails = {
    type: NotificationType
    header: string | ReactNode,
    subHeader: string | ReactNode,
    actionBtnText: string,
    onClick: () => void
    isChecked: boolean
    addSplitLine?: boolean
    disabled?: boolean
    legalText?: string
};
